module.exports = __webpack_public_path__ + "static/media/toggle-off.734e45e4.svg";